<template>
  <a-drawer width="60%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="订单编号" prop="id" >
        <a-input disabled v-model="form.id" placeholder="请输入订单编号" />
      </a-form-model-item>
      <a-form-model-item label="状态" prop="status" >
        <span v-if="form.status == 0">待支付</span>
        <span v-if="form.status == 1">已支付</span>
        <span v-if="form.status == 2">已发货</span>
        <span v-if="form.status == 3">已完成</span>
        <span v-if="form.status == 4">已售后</span>
        <span v-if="form.status == 5">待评价</span>
        <span v-if="form.status == -1">已取消</span>
      </a-form-model-item>
      <a-form-model-item label="总金额" prop="totalAmount" >
        <a-input disabled v-model="form.totalAmount" placeholder="请输入总金额" />
      </a-form-model-item>
<!--      <a-form-model-item label="优惠金额" prop="discountAmount" >-->
<!--        <a-input v-model="form.discountAmount" placeholder="请输入优惠金额" />-->
<!--      </a-form-model-item>-->
      <a-form-model-item label="用户姓名" prop="nickname" >
        <a-input disabled v-model="form.nickname" placeholder="请输入用户ID" />
      </a-form-model-item>
      <a-form-model-item label="支付金额" prop="payAmount" >
        <a-input disabled v-model="form.payAmount" placeholder="请输入支付金额" />
      </a-form-model-item>
<!--      <a-form-model-item label="消耗积分数" prop="reduceScores" v-if="form.type == 1">-->
<!--        <a-input disabled v-model="form.reduceScores" placeholder="请输入消耗积分数" />-->
<!--      </a-form-model-item>-->
      <a-form-model-item label="消耗现金券额度" prop="reduceVoucher" v-if="form.type == 2">
        <a-input disabled v-model="form.reduceVoucher" placeholder="请输入消耗现金券额度" />
      </a-form-model-item>
      <a-form-model-item label="运费" prop="freightAmount" >
        <a-input disabled v-model="form.freightAmount" placeholder="请输入运费" />
      </a-form-model-item>
      <a-form-model-item label="支付方式" prop="payType" v-if="form.status !=-1 && form.status != 1" >
        <span v-if="form.payType == 0">余额</span>
        <span v-if="form.payType == 1">微信</span>
        <span v-if="form.payType == 2">支付宝</span>
      </a-form-model-item>
      <a-form-model-item label="支付时间" prop="payTime" v-if="form.status !=-1 && form.status != 1" >
        <a-date-picker disabled style="width: 100%" v-model="form.payTime" format="YYYY-MM-DD HH:mm:ss" allow-clear/>
      </a-form-model-item>
      <a-form-model-item label="收货地址" prop="address" >
        <a-input disabled v-model="form.address" placeholder="" />
      </a-form-model-item>
<!--      <a-form-model-item label="物流公司" prop="logisticsCompany" >-->
<!--        <a-input disabled v-model="form.logisticsCompany" placeholder="请输入物流公司" />-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="物流单号" prop="logisticsNumber" >-->
<!--        <a-input disabled v-model="form.logisticsNumber" placeholder="请输入物流单号" />-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="备注" prop="remark" >-->
<!--        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />-->
<!--      </a-form-model-item>-->

      <a-table
        :loading="false"
        :size="500"
        rowKey="id" :scroll="{x: 1500,y:'calc(100vh - 300px)'}"
        :columns="columns"
        :data-source="form.orderItemList"
        :pagination="false"
        :bordered="false"
      >
        <span slot="image" slot-scope="text, record">
           <img v-viewer  style="width: 48px;height: 48px;margin-top: 5px;margin-right: 5px;" v-if="record.image"
                :src="record.image" preview="头像"/>
        </span>
      </a-table>
      <div class="bottom-control">
        <a-space>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
// import { getOrderOrder, addOrderOrder, updateOrderOrder } from '@/api/order/orderOrder'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        type:null,
        status: 0,

        totalAmount: null,

        discountAmount: null,

        nickname: null,

        payAmount: null,

        reduceScores: null,

        reduceVoucher: null,

        freightAmount: null,

        payType: null,

        payTime: null,

        orderItemList:[],

        logisticsCompany: null,

        address: null,

        logisticsNumber: null,

        createTime: null,

        remark: null,

      },
      columns: [

        // {
        //   title: '商品ID',
        //   dataIndex: 'productId',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '商品名称',
          dataIndex: 'prodName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '状态',
          dataIndex: 'status',
          ellipsis: true,
          align: 'center',
          customRender(f){
            if(f == 0){
              return '待支付'
            }else if(f == 1){
              return '已支付'
            }else if(f == 2){
              return '已发货'
            }else if(f == 3){
              return '已完成'
            }else if(f == 4){
              return '已售后'
            }else if(f == 5){
              return '待评价'
            }else if(f == -1){
              return '已取消'
            }else{
              return '售后完成'
            }
          }
        },
        {
          title: '商品数量',
          dataIndex: 'quantity',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '图片',
          dataIndex: 'image',
          ellipsis: true,
          align: 'center',
          scopedSlots: {customRender: 'image'}
        },
        {
          title: '规格名称',
          dataIndex: 'skuName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '消耗现金券额度',
          dataIndex: 'cashCoupon',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '消耗积分数',
          dataIndex: 'requireScores',
          ellipsis: true,
          align: 'center'
        },
        // {
        //   title: '运费',
        //   dataIndex: 'freight',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '物流公司',
          dataIndex: 'logisticsCompany',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '物流单号',
          dataIndex: 'logisticsNumber',
          ellipsis: true,
          align: 'center'
        },

      ],
      // 1增加,2修改
      formType: 1,
      open: false,
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        type:null,
        orderNo: null,
        status: 0,
        totalAmount: null,
        discountAmount: null,
        nickname: null,
        payAmount: null,
        reduceScores: null,
        reduceVoucher: null,
        freightAmount: null,
        payType: null,
        payTime: null,
        quantity: null,
        address: null,
        logisticsCompany: null,
        logisticsNumber: null,
        createTime: null,
        orderItemList: [],
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getOrderOrder({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '订单详情'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateOrderOrder(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addOrderOrder(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
